import { Injectable } from '@angular/core';
import { engagementListWithAvailabilityMapper } from '@epicuro-next/data/engagement/engagement-api-utils';
import { ProductsLoadAvailabilitiesRequestDto } from '@epicuro-next/data/engagement/engagement-models';
import { ProductService } from '@epicuro-next/data/product';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { extractUniqueReferences } from '../../utils';

@Injectable({
  providedIn: 'root',
})
export class ProductsAvailabilityApi {
  constructor(private productService: ProductService) {}

  public loadAvailabilities({
    lists,
    accountId,
    siteId,
  }: ProductsLoadAvailabilitiesRequestDto) {
    if (!lists.filter((item) => item.productsReference?.length).length) {
      return of(lists);
    }

    const allListProductReferences = extractUniqueReferences(lists);

    return this.productService
      .checkProductsAvailabilityByReferences(accountId ?? '', {
        productReferences: allListProductReferences,
        siteId: siteId ?? '',
      })
      .pipe(
        take(1),
        map(({ availableProductReferences, unavailableProductReferences }) =>
          engagementListWithAvailabilityMapper(
            lists,
            availableProductReferences,
            unavailableProductReferences,
          ),
        ),
        catchError(() => of(lists)),
      );
  }
}
